import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, Button } from "@mui/material";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";

import "./index.scss";

/**
 * Shared empty state.
 *
 * `lable` is kept (misspelling and all) because 40-odd call sites pass it;
 * `label` is accepted for new code.
 */
export default function NoData({
  lable,
  label,
  description,
  icon,
  actionLabel,
  onAction,
  overlay = true,
}) {
  const message = label || lable;

  return (
    <Box className={`no-data${overlay ? " no-data--overlay" : ""}`}>
      <Box className="no-data__icon" aria-hidden="true">
        {icon || <InboxOutlinedIcon fontSize="inherit" />}
      </Box>

      {message && <Typography className="no-data__message">{message}</Typography>}

      {description && (
        <Typography className="no-data__description">{description}</Typography>
      )}

      {actionLabel && onAction && (
        <Button className="no-data__action" variant="contained" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </Box>
  );
}

NoData.propTypes = {
  lable: PropTypes.node,
  label: PropTypes.node,
  description: PropTypes.node,
  icon: PropTypes.node,
  actionLabel: PropTypes.node,
  onAction: PropTypes.func,
  overlay: PropTypes.bool,
};

NoData.defaultProps = {
  lable: null,
  label: null,
  description: null,
  icon: null,
  actionLabel: null,
  onAction: null,
  overlay: true,
};
